module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.4fbdcf47.svg";